import * as Sentry from '@sentry/nextjs'

export type Env = 'local' | 'dev' | 'qa' | 'preprod' | 'prod'

export const getSampleRatesByEnv = (env: Env): { tracesSampleRate: number; sampleRate: number } => {
  const tracesSampleRate =
    env === 'prod'
      ? 0.001 //0.1% for prod env
      : 0 // 0 for other envs

  const errorSampleRate =
    env === 'prod'
      ? 0.01 //1% for prod env
      : 0 // 0 for other envs

  return {
    tracesSampleRate,
    sampleRate: errorSampleRate,
  }
}

export const sentryInit = <T extends Sentry.NodeOptions | Sentry.BrowserOptions>(env: Env, options: T) => {
  const service = process.env.SERVICE_NAME
  const buildTag = process.env.BUILD_TAG

  Sentry.init({
    dsn: 'https://44d5cb46d3ce49848904b7055ab91109@o565714.ingest.sentry.io/4504171568037888',
    environment: env,
    release: `${service}@${buildTag}`,
    autoSessionTracking: true,
    ...options,
  })
}
